import { gql } from '@apollo/client'
import { mutate, query } from 'shared/helpers/graphql'

export async function getRoomDesignClassifications() {
  return query(gql`
    query Room_design_classifications {
      room_design_classifications {
        id
        name
      }
    }
  `)
}

export async function upsertRoomDesign(payload) {
  return mutate(
    {
      roomDesigns: [payload],
    },
    gql`
      mutation Upsert_room_designs($roomDesigns: [room_designs_input]) {
        upsert_room_designs(room_designs: $roomDesigns) {
          id
        }
      }
    `,
  )
}

export async function deleteRoomDesign(id) {
  return mutate(
    {
      deleteRoomDesignsId: id,
    },
    gql`
      mutation Mutation($deleteRoomDesignsId: Int!) {
        delete_room_designs(id: $deleteRoomDesignsId) {
          id
        }
      }
    `,
  )
}
